import React, {Component} from 'react';
import '../css/HomePage.css';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {COLORS} from '../constants';
import {HomePage as hps} from '../strings';
import {Button as bs} from '../strings';
import ContactForm from './ContactForm';
import Button from './Button';
import {getLang, getUsers} from '../selectors';
import {fetchUsers} from '../actions';


class HomePage extends Component {

  static defaultProps = {
    lang: 'en',
  }

  componentWillMount() {
    //const {fetchUsers} = this.props;

    //fetchUsers();
  }

  componentDidMount() {
    window.scrollTo(0,0);
  }

  renderSections() {
    const {lang} = this.props;
    const sections = ['p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'p7'];
    return sections.map((key, index) => {
      const value = hps[key][lang];
      return (
        <p 
          key={index}
          style={s.p}
        >
          {value}
        </p>
      )
    })
  }

  render() {
    const {
      lang,
    } = this.props;

    return(
      <div style={s.container} className='home-page'>

        <div style={s.contentContainer} className="fade-in">

          <div style={s.titleContainer}>
            <h1 style={s.title} className='title'>
              {hps.title[lang]}
            </h1>
            <div style={s.subtitle} className='subtitle'>
              {hps.subtitle[lang]}
            </div>
          </div>

          <div style={s.descriptionContainer}>
            <p style={s.p}>{hps.p1[lang]}</p>
            <div style={s.programsButton}>
              <Button
                label={bs.viewPrograms[lang]}
                color="orange"
                link="/programs"
              />
            </div>
            <p style={s.p}>{hps.p2[lang]}</p>
            <p style={s.p}>{hps.p3[lang]}</p>
            <p style={s.p}>{hps.p4[lang]}</p>
            <p style={s.p}>{hps.p5[lang]}</p>
            <p style={s.p}>{hps.p6[lang]}</p>
            <p style={s.p}>{hps.p7[lang]}</p>
          </div>

          <div 
            style={s.contactFormContainer}
            id="HomePage-contactFormContainer"
          >
            <ContactForm 
              shouldRenderInfo={true}
              shouldRenderForm={false} 
            />
          </div>

          <div style={s.programsButtonContainer}>
            <Button
              label={bs.viewPrograms[lang]}
              color="orange"
              link="/programs"
            />
          </div>
          
        </div>
      </div>
    )
  }
}

const maxWidth = '600px';


const s = {
  container: {
    height: '100%',
    backgroundColor: COLORS.black,
    color: COLORS.white,
  },
  titleContainer: {
    marginTop: '10px',
    marginBottom: '40px',
  },
  title: {

  },
  subtitle: {

  },
  historia: {
    fontWeight: 'bold',
    fontSize: '200%',
    letterSpacing: '20px',
    margin: '0px 20px',
  },
  learningCoop: {
    fontSize: '100%',
    letterSpacing: '10px',
    color: COLORS.fadedWhite,
    textTransform: 'uppercase',
  },
  contentContainer: {
    maxWidth,
    margin: 'auto',
    backgroundColor: COLORS.black,
    marginTop: '20px',
    padding: '20px',
  },
  descriptionContainer: {
    fontSize: '100%',
    textAlign: 'justify',
  },
  p: {
    color: COLORS.gray200,
    fontSize: '100%',
    lineHeight: '1.7',
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '50px',
  },
  contactFormContainer: {
    marginTop: '60px',
    marginBottom: '40px',
  },
  programsButtonContainer: {
    display: 'inline-block',
    marginBottom: '40px',
  },
  programsButton: {
    display: 'inline-block',
    margin: '10px 0px',
    marginBottom: '20px',
  },
}

const mapStateToProps = (state, ownProps) => {
  return {
    lang: getLang(state),
    users: getUsers(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUsers: (params) => dispatch(fetchUsers(params)),
  }
}


const Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(HomePage)

export default withRouter(Connected);



// WEBPACK FOOTER //
// ./src/main/HomePage.js